module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/ian_shrug_laugh.png
// module id = 2495
// module chunks = 2